import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Box, Typography, Chip, CircularProgress } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";

function prettifyStatus(s) {
  switch (s) {
    case "failed":
      return { label: "Hata", color: "error" };
    case "manual_rejected":
      return { label: "Admin Reddetti", color: "error" };
    default:
      return { label: s, color: "default" };
  }
}

function formatDate(dt) {
  if (!dt) return "—";
  const d = new Date(dt);
  return d.toLocaleString("tr-TR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

const PaymentErrorsPage = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const getAuthHeaders = useCallback(() => {
    const token =
      localStorage.getItem("token") ||
      sessionStorage.getItem("token");

    return token ? { Authorization: `Bearer ${token}` } : {};
  }, []);

  const columns = useMemo(() => [
    {
      field: "userName",
      headerName: "Kullanıcı",
      flex: 1.2,
      renderCell: (params) => (
        <Box height="100%" display="flex" flexDirection="column" justifyContent="center">
          <Typography fontWeight={600} variant="body2">
            {params.row.userName}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {params.row.userEmail}
          </Typography>
        </Box>
      ),
    },
    {
      field: "packageName",
      headerName: "Paket",
      flex: 0.8,
      renderCell: (params) => (
        <Box height="100%" display="flex" flexDirection="column" justifyContent="center">
          <Typography variant="body2">
            {params.row.packageName || "—"}
          </Typography>
        </Box>
      ),
    },
    {
      field: "errorText",
      headerName: "Hata Mesajı",
      flex: 2,
      renderCell: (params) => (
        <Box height="100%" display="flex" flexDirection="column" justifyContent="center">
          <Typography
            variant="body2"
            sx={{ whiteSpace: "normal", lineHeight: 1.3 }}
          >
            {params.row.errorText}
          </Typography>
        </Box>
      ),
    },
    {
      field: "status",
      headerName: "Durum",
      flex: 0.7,
      renderCell: (params) => {
        const s = prettifyStatus(params.row.status);
        return (
          <Chip
            size="small"
            label={s.label}
            color={s.color}
            variant="outlined"
          />
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Tarih",
      flex: 1,
      renderCell: (params) => (
        <Box height="100%" display="flex" flexDirection="column" justifyContent="center">
          <Typography variant="body2">
            {formatDate(params.row.createdAt)}
          </Typography>
        </Box>
      ),
    },
  ], []);

  useEffect(() => {
    const fetchErrors = async () => {
      try {
        setLoading(true);
        const res = await axios.get("/api/admin/payments/errors", {
          headers: getAuthHeaders(),
        });
        setRows(res.data || []);
      } catch (err) {
        console.error("payment errors load error:", err);
        setRows([]);
      } finally {
        setLoading(false);
      }
    };

    fetchErrors();
  }, [getAuthHeaders]);

  return (
    <Box p={3}>
      <Box>
        <Typography variant="body2" color="text.secondary">
          Ödeme sağlayıcısı hataları veya admin tarafından reddedilen manuel ödemeler
        </Typography>
      </Box>

      <Box
        sx={{
          width: "100%",
          "& .MuiDataGrid-root": {
            borderRadius: 2,
          },
        }}
      >
        {loading ? (
          <Box
            py={8}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box mb={2} sx={{ width: "97%" }}>
            <DataGrid
              rows={rows}
              columns={columns}
              getRowId={(row) => row.id}
              pageSize={10}
              autoHeight
              disableRowSelectionOnClick
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PaymentErrorsPage;